import { useTransition } from 'react-spring';
import Cross from '@assets/svg/plus.svg';
import Link from 'next/link';
import { AppVer, Backdrop, CloseButton, MenuContainer, MenuItem, MenuItems, MenuWrap, NoteficationCount } from './SideMenu.styled';
import { memo, useEffect, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import UserProfile from '@components/UserProfile';
import { useAuthentication } from '@providers/AuthProvider';
import { useStore } from '@store/appStore';
import { useWindowSize } from 'react-use';
import { useRouter } from 'next/router';
import routeChangeHook from '@hooks/routeChangeHook';
import useDetectOutsideClick from '@hooks/useDetectOutsideClick';
import LanguagePicker from '@components/Buttons/LanguagePicker';
import db from '@utils/db';
import i18n from 'i18next';
import { breakpoints } from '@styles/tokens';

export const SideMenu = () => {
  const { menuOpen, setMenuOpen, setQRScreen } = useStore();
  const { error } = useAuthentication();
  const transition = useTransition(menuOpen && !error, {
    from: { transform: `translate3d(100%,0,0)` },
    enter: { transform: `translate3d(0%,0,0)` },
    leave: { transform: `translate3d(100%,0,0)` },
  });

  return transition((style, item) => {
    return (
      item && (
        <MenuWrap style={style}>
          <MainMenu />
        </MenuWrap>
      )
    );
  });
};

const MainMenu = () => {
  const { user, groups, logout, getStudentId } = useAuthentication();
  const { client, settings, systemSettings, setQRScreen, setNote, setSelectedStudent, whoIsLoggedIn, setNoteUserId, callNameSetting } = useStore();
  const { height, width } = useWindowSize();
  const { setMenuOpen, appVer } = useStore();
  const { pathname } = useRouter();
  const closeMenu = () => setMenuOpen(false);
  const [pages, setPages] = useState(null);
  routeChangeHook(closeMenu);
  const wrapperRef = useRef(null);
  let SchoolName = ""
  let showQrCode = false;
  if (systemSettings) {
    let s = systemSettings.find((t) => t.APP_Setting_ID === 65);
    if (s) SchoolName = s.value
    let s2 = systemSettings.find((t) => t.APP_Setting_ID === 103);
    if (s2) showQrCode = s2.value.toLowerCase() === 'true';  }

  useDetectOutsideClick(wrapperRef, handleOutsideClick);

  function handleOutsideClick() {
    setMenuOpen(false);
  }

  useEffect(() => {
    constructPages();
  }, [groups, client, user]);

  function constructPages() {
    if (!groups || !client || !user || !systemSettings) {
      return;
    }

    let selfRegistration = systemSettings.find((t) => t.APP_Setting_ID === 43);
    let useCoins = systemSettings.find((t) => t.APP_Setting_ID === 21);
    let studentSick = systemSettings.find((t) => t.APP_Setting_ID === 50);
    let allowNotes = systemSettings.find((t) => t.APP_Setting_ID === 9);
    let allowStudentNotes = systemSettings.find((t) => t.APP_Setting_ID === 45);
    let useWrittenAbsence = systemSettings.find((t) => t.APP_Setting_ID === 58);
    let rootPage = false;
    
    const pageArr = [];

    if(groups?.includes(client?.StudentGroupQROnly)){
      
    } else {
      
      if (groups?.includes(client?.SchoolLeaderGroupName) && width >= breakpoints.tablet) {
        
        pageArr.push({ title_id: 'leader', url: '/' });
        rootPage = true;
      }
      
      if (groups?.includes(client?.SchoolSecretaryGroupName) && width >= breakpoints.tablet && !rootPage) {
        pageArr.push({ title_id: 'secretary', url: '/' });
        rootPage = true;
      }
      
      if (groups?.includes(client?.GuestTeacherGroupName) || groups?.includes(client?.RegisterGroupName) || groups?.includes(client?.AdminGroupName)) {
        pageArr.push({ title_id: 'menu-registration', url: rootPage ? '/registration' : '/' });
        rootPage = true;
      }
      
      if ((groups?.includes(client?.RegisterGroupName) || (groups?.includes(client?.AdminGroupName))) && selfRegistration.value.toLowerCase() === 'true' && showQrCode) {
        pageArr.push({ title_id: 'menu-qr', url: '/qr' });
        //pageArr.push({ title_id: 'menu-qr-online', url: '/qr-online' });
      }

      if ((groups?.includes(client?.RegisterGroupName) || groups?.includes(client?.AdminGroupName))) {
        pageArr.push({ title_id: 'menu-teacherpage', url: '/teacherpage' });
        if (useWrittenAbsence.value.toLowerCase() === 'true' && (settings.DEMO !== 'true' && settings.DEMO !== true)) pageArr.push({ title_id: 'menu-sf', url: '/writtenabsence' });
        rootPage = true;
      }
      
      if (groups?.includes(client?.StudentGroupName) && !rootPage) {
        pageArr.push({ title_id: 'profile', url: '/' });
        if (selfRegistration.value.toLowerCase() === 'true' || settings.DEMO === 'true' || settings.DEMO === true) {
          pageArr.push({ title_id: 'menu-qr-scan', url: 'qr' });
        }
        if (allowNotes.value.toLowerCase() === 'true' && allowStudentNotes.value.toLowerCase() === 'true')
          pageArr.push({ title_id: 'menu-note', url: 'note' });
        if (studentSick.value.toLowerCase() === 'true') pageArr.push({ title_id: 'menu-absence', url: 'absence' });
        rootPage = true;
      }
      
      if (groups?.includes(client?.AdminGroupName) || (groups?.includes(client?.TeacherGroupName))) {
        pageArr.push({ title_id: 'menu-adminpage', url: '/adminpage' });
        //pageArr.push({ title_id: 'guardian', url: '/guardian' });   
        //pageArr.push({ title_id: 'approval-header', url: '/approval'});   
        //pageArr.push({ title_id: 'School Leader', url: '/schoolleader'});   
      }
      if (groups?.includes(client?.GuardianEditorGroupName)) {
        pageArr.push({ title_id: 'menu-guardianedit', url: '/guardianeditor' });   
      }
      
      
      if (groups?.includes(client?.GuardianGroupName)  && !rootPage) {
        pageArr.push({ title_id: 'menu-parent', url: '/' });
        rootPage = true;
      }
      
      if (groups?.includes(client?.CaseWorkerGroupName)) {
        pageArr.push({ title_id: 'my', title_id2: callNameSetting + "-s", url: rootPage ? '/caseworker' : '/' });
        rootPage = true;
      }
      
      if (groups?.includes(client?.CustomReportUIGroupName)) {
        pageArr.push({ title_id: 'counselor', url: '/counselor' });
        
      }
      
      if (groups?.includes(client?.SuperAdminGroupName)) {
        pageArr.push({ title_id: 'menu-studentadmin', url: rootPage ? '/studentadmin' : '/' });
        rootPage = true;
      }
      
      if (groups?.includes(client?.AdminGroupName) && settings.USEMERIT && !(settings.DEMO || settings.DEMO === "true")) {
        pageArr.push({ title_id: 'merit-header', url: '/merit' });
      }
      
      
      if (groups?.includes(client?.RedeemGroupName) && useCoins.value.toLowerCase() === 'true') {
        pageArr.push({ title_id: 'menu-redeempage', url: rootPage ? '/redeem' : '/' });
        rootPage = true;
      }
      
      if (groups?.includes(client?.RewardAdminGroupName)) {
        pageArr.push({ title_id: 'menu-rewardpage', url: rootPage ? '/reward' : '/' });
        rootPage = true;
      }

      //  if (groups?.includes(client?.RewardAdminGroupName)) {
      //   pageArr.push({ title_id: 'Redeem Setup', url: rootPage ? '/redeem-setup' : '/' });
      // }

      if (groups?.includes(client?.RewardAdminGroupName)) {
        pageArr.push({ title_id: 'badge-page-title', url: rootPage ? '/badge-setup' : '/' });
      }
      
      if (groups?.includes(client?.RewardShopClerkGroupName)) {
        pageArr.push({ title_id: 'menu-rewardQRpage', url: rootPage ? '/redeemqr' : '/' });
        rootPage = true;
      }
      
      pageArr.push({ title_id: 'settings', url: '/settings' });
    }
      if ((!settings.TEAMS || settings.TEAMS === 'false') && (!settings.DEMO || settings.DEMO !== 'true'))
        pageArr.push({ title_id: 'menu-logout', url: '/logout' });
      
      setPages(pageArr);
  }

  function menuLogout(e) {
    e.preventDefault();
    logout();
  }

  function QRMenu(e) {
    e.preventDefault();
    closeMenu();
    setQRScreen(true);
  }

  function NoteMenu(e) {
    e.preventDefault();
    closeMenu();

    let id = getStudentId();
    if (id) {
      setNoteUserId(id);
      setNote(true);
    }
  }

  return (
    <MenuContainer ref={wrapperRef} style={{ height: height }}>
      {/* {<AppVer>Version: {appVer}</AppVer>} */}
      {<AppVer>
        <span>{SchoolName}</span>
        <span>Version: {appVer}</span>
      </AppVer>}
      <CloseButton onClick={closeMenu}>
        <Cross />
      </CloseButton>
      <MenuItems>
        {pages &&
          pages.map(({ title_id, url, title_id2 }, i) => {
            if (url === '/logout')
              return (
                <MenuLink
                  url={url}
                  pathname={pathname}
                  click={menuLogout}
                  closeMenu={closeMenu}
                  key={i}
                  title_id={title_id}
                  title_id2={title_id2}
                  notification={false}
                />
              );
            else if (url === '/approval')
              return (
                <MenuLink
                  url={url}
                  pathname={pathname}
                  click={undefined}
                  closeMenu={closeMenu}
                  key={i}
                  title_id={title_id}
                  title_id2={title_id2}
                  notification={true}
                />
              );
            else if (url === 'qr')
              return (
                <MenuLink
                  url={''}
                  pathname={pathname}
                  click={QRMenu}
                  closeMenu={closeMenu}
                  key={i}
                  title_id={title_id}
                  title_id2={title_id2}
                  notification={false}
                />
              );
            else if (url === 'note')
              return (
                <MenuLink
                  url={''}
                  pathname={pathname}
                  click={NoteMenu}
                  closeMenu={closeMenu}
                  key={i}
                  title_id={title_id}
                  title_id2={title_id2}
                  notification={false}
                />
              );
            else
              return (
                <MenuLink
                  url={url}
                  pathname={pathname}
                  click={undefined}
                  closeMenu={closeMenu}
                  key={i}
                  title_id={title_id}
                  title_id2={title_id2}
                  notification={false}
                />
              );
          })}
        <LanguagePicker />
        <UserProfile showPicture={true} usingTopMenu={false} />
      </MenuItems>
      <Backdrop />
    </MenuContainer>
  );
};

const MenuLink = ({ url, pathname, closeMenu, title_id, click, title_id2, notification }) => {
  const i18n = useI18n();
  const { notificationCounter } = useStore();
  return (
    <Link href={url || ''} legacyBehavior passHref>
      {/* MenuItem is styled.a - a real anchor - so this Link must stay in
      legacyBehavior mode; without it, Link renders its own <a> around
      MenuItem's <a>, producing invalid nested anchors that break clicks on
      items relying on their own onClick (logout/QR/note), since the browser
      un-nests them at parse time. */}
      <MenuItem active={pathname == url} onClick={click ? click : closeMenu}>
        {title_id2 ? i18n.t(title_id) + ' ' + i18n.t(title_id2) : i18n.t(title_id)}
        {notification && notificationCounter > 0 ? <NoteficationCount>{notificationCounter}</NoteficationCount> : null
        }
      </MenuItem>
    </Link>
  );
};

export default memo(SideMenu);
